module.exports = __webpack_public_path__ + "img/location.9ce89d2.png";